module.exports = __webpack_public_path__ + "img/symphony_238_beige.325b8947.jpg";